import { render, staticRenderFns } from "./SalesThermalpkReports.vue?vue&type=template&id=78b70a64&"
import script from "./SalesThermalpkReports.vue?vue&type=script&lang=js&"
export * from "./SalesThermalpkReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports